import React, { useCallback, useState, createContext, useContext } from 'react';
import { track } from './fbpixel';
const CHECKOUT_URL = 'https://www.ebookpromax.com/cart/52513378631973:1';
const CHECKOUT_URL_WITH_BUMP = 'https://www.ebookpromax.com/cart/52513432600869:1';
// Exit-intent special: main product + order bump at 30% off the bump
const CHECKOUT_URL_EXIT_SPECIAL = 'https://www.ebookpromax.com/cart/52516922884389:1';
type CheckoutContextValue = {
  orderBumpChecked: boolean;
  setOrderBumpChecked: (v: boolean) => void;
  checkoutUrl: string;
  fireInitiateCheckout: () => void;
  requestCheckout: () => void;
  exitPopupOpen: boolean;
  closeExitPopup: () => void;
  acceptExitOffer: () => void;
  declineExitOffer: () => void;
};
const CheckoutContext = createContext<CheckoutContextValue | null>(null);
const openUrl = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
export const CheckoutProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [orderBumpChecked, setChecked] = useState(false);
  const [exitPopupOpen, setExitPopupOpen] = useState(false);
  const checkoutUrl = orderBumpChecked ? CHECKOUT_URL_WITH_BUMP : CHECKOUT_URL;
  const setOrderBumpChecked = useCallback((v: boolean) => {
    setChecked(v);
    if (v) {
      track('AddToCart', {
        content_name: 'Recorta, Arma y Pega',
        content_type: 'product',
        currency: 'ARS',
        value: 9999
      });
    }
  }, []);
  const fireInitiateCheckout = useCallback(() => {
    track('InitiateCheckout', {
      content_name: 'Kit Educativo 15 en 1',
      content_type: 'product',
      currency: 'ARS',
      value: orderBumpChecked ? 31998 : 21999
    });
  }, [orderBumpChecked]);
  // Main checkout intent handler:
  // - If the order bump is selected -> go straight to the full-bundle cart.
  // - If NOT selected -> show the exit-intent upsell popup instead.
  const requestCheckout = useCallback(() => {
    if (orderBumpChecked) {
      fireInitiateCheckout();
      openUrl(CHECKOUT_URL_WITH_BUMP);
    } else {
      setExitPopupOpen(true);
    }
  }, [orderBumpChecked, fireInitiateCheckout]);
  const closeExitPopup = useCallback(() => setExitPopupOpen(false), []);
  const acceptExitOffer = useCallback(() => {
    track('AddToCart', {
      content_name: 'Recorta, Arma y Pega (oferta especial)',
      content_type: 'product',
      currency: 'ARS',
      value: 6999.3
    });
    track('InitiateCheckout', {
      content_name: 'Paquete Completo (oferta especial)',
      content_type: 'product',
      currency: 'ARS',
      value: 28998.3
    });
    setExitPopupOpen(false);
    openUrl(CHECKOUT_URL_EXIT_SPECIAL);
  }, []);
  const declineExitOffer = useCallback(() => {
    track('InitiateCheckout', {
      content_name: 'Kit Educativo 15 en 1',
      content_type: 'product',
      currency: 'ARS',
      value: 21999
    });
    setExitPopupOpen(false);
    openUrl(CHECKOUT_URL);
  }, []);
  return <CheckoutContext.Provider value={{
    orderBumpChecked,
    setOrderBumpChecked,
    checkoutUrl,
    fireInitiateCheckout,
    requestCheckout,
    exitPopupOpen,
    closeExitPopup,
    acceptExitOffer,
    declineExitOffer
  }} data-id="element-70">
      {children}
    </CheckoutContext.Provider>;
};
export const useCheckout = () => {
  const ctx = useContext(CheckoutContext);
  if (!ctx) throw new Error('useCheckout must be used within CheckoutProvider');
  return ctx;
};